import angular from 'angular';

import RadioComponent from './radio.cmpt';

export default angular
    .module('application.component.radio', [])
    .component(RadioComponent.selector, RadioComponent);



// WEBPACK FOOTER //
// ./src/application/component/radio/index.js